import { render, staticRenderFns } from "./layout-global-menu-row.vue?vue&type=template&id=f11d2c38&scoped=true&"
import script from "./layout-global-menu-row.vue?vue&type=script&lang=js&"
export * from "./layout-global-menu-row.vue?vue&type=script&lang=js&"
import style0 from "./layout-global-menu-row.vue?vue&type=style&index=0&id=f11d2c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11d2c38",
  null
  
)

export default component.exports